/*
#############################################################################
# Copyright (c) 2022-2023 NVIDIA CORPORATION & AFFILIATES. All rights reserved.
#
# NVIDIA CORPORATION, its affiliates and licensors retain all intellectual
# property and proprietary rights in and to this material, related
# documentation and any modifications thereto. Any use, reproduction,
# disclosure or distribution of this material and related documentation
# without an express license agreement from NVIDIA CORPORATION or
# its affiliates is strictly prohibited.
###############################################################################
*/

/* eslint-disable no-param-reassign */
/* eslint-disable no-console */
import axios from "axios";
import uiConfig from "../../config/config";

export default function interceptAndAppendHeaders() {
  axios.interceptors.request.use(
    (config) => {
      if (uiConfig.enableEngress) {
      /**
       * whether or not cross-site Access-Control requests should be made using credentials such as cookies, 
       * authorization headers or TLS client certificates.
       */
        config.withCredentials = true;
      }
      // Add Authorization header individually wherever required because its not required for all API calls
      return config;
    },
    (error) => Promise.reject(error)
  );
}
